import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const COLS = [
  {
    title: "Shop",
    links: [
      { label: "Men's Innerwear", to: "/collection/mens-innerwear" },
      { label: "Winter Socks", to: "/collection/winter-socks" },
      { label: "Winter Footwear", to: "/collection/winter-footwear" },
      { label: "Everyday Essentials", to: "/collection/essentials" },
      { label: "Best Sellers", to: "/collection/best-sellers" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "About LEMCE", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "FAQ", to: "/faqs" },
      { label: "Track Order", to: "/account" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Shipping", to: "/shipping" },
      { label: "Returns & Exchanges", to: "/returns" },
      { label: "FAQs", to: "/faqs" },
      { label: "Care Guide", to: "/care" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("Welcome to THE LEMCE EDIT", { description: "You're on the list." });
    setEmail("");
  };

  return (
    <footer className="bg-lemce-matte text-lemce-ivory" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-14 pb-14 border-b border-white/10">
          <div>
            <p className="text-[11px] tracking-widest uppercase text-lemce-taupe mb-3">THE LEMCE EDIT</p>
            <h3 className="font-serif text-3xl lg:text-4xl mb-4 leading-tight text-lemce-ivory">
              New launches, winter stories<br />and considered comfort.
            </h3>
            <p className="text-sm text-white/60 mb-6 max-w-md">Delivered occasionally — never noisy. Join for early access to launches and quiet-luxury essentials.</p>
            <form onSubmit={submit} className="flex max-w-md border-b border-white/30">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                data-testid="newsletter-input"
                className="flex-1 bg-transparent py-3 outline-none text-sm placeholder:text-white/40"
              />
              <button type="submit" aria-label="Subscribe" data-testid="newsletter-submit" className="px-2">
                <ArrowRight className="w-5 h-5" strokeWidth={1.5} />
              </button>
            </form>
          </div>

          <div className="grid grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <p className="text-[11px] tracking-widest uppercase text-lemce-taupe mb-4">{col.title}</p>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.to} className="text-sm text-white/70 hover:text-lemce-ivory transition-colors">{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-10">
          <span className="font-serif text-2xl tracking-[0.35em]">LEMCE</span>
          <p className="text-xs text-white/50 tracking-wide order-3 md:order-2">© {new Date().getFullYear()} LEMCE. Comfort That Stays With You.</p>
          <div className="flex items-center gap-5 order-2 md:order-3">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram className="w-4 h-4 text-white/70 hover:text-lemce-ivory transition-colors" strokeWidth={1.5} /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook className="w-4 h-4 text-white/70 hover:text-lemce-ivory transition-colors" strokeWidth={1.5} /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube className="w-4 h-4 text-white/70 hover:text-lemce-ivory transition-colors" strokeWidth={1.5} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
